import { ReactNode, JSX } from 'react';
import { checkAccess } from '@/finsight/application/User/helpers';

interface IProps {
  checks: boolean[],
  fallback?: ReactNode | JSX.Element,
  children?: ReactNode | JSX.Element,
}

const CheckUserAccess = ({
  checks,
  fallback = null,
  children,
}: IProps) => {
  const shouldRender = checkAccess(checks);

  return <>{ shouldRender ? children : fallback }</>;
};

export default CheckUserAccess;
